import useBillboardPageContext from "pages/[tenant]/browse/hooks/useBillboardPageContext";

import SoundOff from "shared/assets/icons/SoundOff";
import SoundOn from "shared/assets/icons/SoundOn";

import { SoundButtonContainer } from "./styles";

export const SoundButton = () => {
  const { backgroundContent, hasSound, pandaPlayerRef, handleToggleSound } =
    useBillboardPageContext();

  const isBackgroundVideo = backgroundContent === "video";

  if (!isBackgroundVideo) return;
  return (
    <SoundButtonContainer onClick={() => handleToggleSound({ pandaPlayerRef })}>
      {!hasSound ? <SoundOff /> : <SoundOn />}
    </SoundButtonContainer>
  );
};
